import React, { useEffect, useState, useContext, useRef } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledTablePmePrograma } from "../../../styled-components/StyledTablePmePrograma.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { DynamicInput } from "../../../components/DynamicInput";
import { StldRow } from "../../../styled-components/StldRow.style";
import { useForm } from 'react-hook-form';
import api from '../../../services/api';
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as moment from 'moment'
import Flex from '@react-css/flex';
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { IconRefresh } from "../../../svg";
import { PaginationCustom } from "../../../components/PaginationCustom";
import { genericList } from "../../../services/genericList";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";

const getListaProgramas = async (formValues, currentPage, pageSize) => {
    let list = null;
    let params = {
        nomePrograma: formValues?.nomePrograma || null,
        currentPage: currentPage || 1,
        pageSize: pageSize || 10,
    };

    try {
        const response = await api.get(`PmePrograma`, { params });
        //console.log("API Response:", response.data);
        list = response.data || [];
        return list;
    } catch (err) {
        //console.error("API Error:", err);
        return [];
    }
}

export const PmeTopFeeMaker = () => {
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const history = useHistory();

    const [searchReadOnly, setSearchReadOnly] = useState(false);
    const [assunto, setAssunto] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [ListaData, setListaData] = useState(null);    
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);

    const [nomePrograma, setNomePrograma] = useState(null);

    const carregarProgramas = async () => {
        setIsLoading(true);
        try {
            const formValues = {
                nomePrograma: nomePrograma || null,
                currentPage: currentPage || 1,
                pageSize: pageSize || 10,   
            };
            const lista = await getListaProgramas(formValues, currentPage, pageSize);            
            setListaData(lista);
        } finally {
            setIsLoading(false);
        }
    };
    
    const getTextStatus = (status) => {
        const textStatus = "ATIVO";
        if(status == 0) {
            textStatus = "INATIVO";
        }
        return textStatus;
    };

    const refreshData = async () => {
    }

    const getacoes = (idPrograma) => {
        return (
            <div className="text-center">
                <span className="cursor-pointer color-icon-default m-1" onClick={() => setRedirectFormEdit(idPrograma)} title="Editar este programa">
                    <i className="fa fa-eye" aria-hidden="true"></i>
                </span>
            </div>
        );

    };

    const setRedirectFormEdit = (idPrograma) => {
        history.push(`/pme-top-fee-maker/${idPrograma}`);
    }

    useEffect(() => {
        const asyncFn = async () => {
            await carregarProgramas();
        }

        asyncFn();
    }, []);

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">PME - Top Fee Maker </h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                    </div>
                    <div className="card">
                        <StldRow>
                            <Flex>
                                <StyledForm style={{ width: "100%" }}>
                                    {isLoading ? 
                                        <StldRow>
                                            <div className="text-center">
                                                <div className="d-flex align-items-center">
                                                    <strong style={{ color: "#EE4B21" }}>Carregando...</strong>
                                                    <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                </div>
                                            </div>
                                        </StldRow> 
                                    : 
                                        <StyledTablePmePrograma>
                                            <StyledTablePage>
                                            {
                                                ListaData?.data?.length > 0 ? 
                                                (
                                                    <div className="table-scroll font-0-9x table-bordered table-container">
                                                        <table className="table table-width">
                                                            <thead>
                                                                <tr className="table-legend-info">
                                                                    <th key="ac">Ações</th>
                                                                    {/* <th key="idPrograma">ID</th> */}
                                                                    <th key="nomePrograma">Nome do Programa</th>
                                                                    <th key="inicio_termino" colSpan={2}>Vigência</th>
                                                                    <th key="status">Status</th>
                                                                    <th key="contemplados">Contemplados</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {ListaData.data
                                                                .sort((a, b) => new Date(b.dataInicio) - new Date(a.dataInicio)) // Ordena do mais recente para o mais antigo
                                                                .map((programa, index) => (
                                                                    <tr key={index}>
                                                                        <td className="text-center">{ getacoes(programa.idPrograma) }</td>
                                                                        {/* <td className="text-center">{ programa.idPrograma }</td> */}
                                                                        <td className="text-center">{ programa.nomePrograma }</td>
                                                                        <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataInicio)) }</td>
                                                                        <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataFim)) }</td>
                                                                        <td className="text-center">{ getTextStatus(programa.status) }</td>
                                                                        <td className="text-center">{ programa.contagemProfissionais }</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ) : ListaData?.data && ListaData.data.length === 0 ? (
                                                    <StldColumn xs="12" sm="12" md="12">
                                                        <div className="alert alert-warning" role="alert">
                                                            Atenção! Nenhum resultado encontrado!
                                                        </div>
                                                    </StldColumn>
                                                ) : (
                                                    <StldColumn xs="12" sm="12" md="12">
                                                        <div className="alert alert-warning" role="alert">
                                                            Erro ao carregar os dados ou estrutura inesperada.
                                                        </div>
                                                    </StldColumn>
                                                )
                                            }
                                        </StyledTablePage>
                                    </StyledTablePmePrograma>}
                                </StyledForm>
                            </Flex>
                        </StldRow>
                        {/* {(() => {
                            if (ListaData != null) {
                                return (
                                    <PaginationCustom isMobile={isMobile}
                                        isDesktop={isDesktop}
                                        length={ListaData?.data?.page?.length ?? 0}
                                        recordsTotal={ListaData?.data?.page?.recordsTotal ?? 0}
                                        currentPage={currentPage ?? 0}
                                        formData={carregarProgramas}
                                        pageSize={pageSize ?? 0}
                                        setPageSize={setPageSize}
                                        setPage={(page) => setCurrentPage(page)} />
                                )
                            }
                            return null
                        })()} */}
                    </div>
                </StyledDefaultPage>
            </main>
        </section >
    );
};


export const TopFeeMakerPmePage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <PmeTopFeeMaker />

                </>
            )}
        </>
    );
};
